import { ILanguage } from "../types";

export const en: ILanguage = {
  translation:{
    root: {
    businessAccount: "Business Account",
    verificationStatus: "Verification Status",
    companyInformation: "COMPANY INFORMATION",
    note: "Note",
    businessName: "Business Name*",
    enterBusinessName: "Enter Business Name",
    registrationNumber: "Company Reg. No.",
    registrationNumberPlaceholder: "Enter Registration Number",
    taxVat: "Tax/VAT Registration No.",
    vatPlaceholder: "Enter Tax/VAT Registration Number",
    registeredAddress: "Registered Address*",
    tradingAddress: "Trading Address*",
    sameAsRegisteredAddress: "Same as Registered Address",
    billingInformation: "Billing Information",
    billingPhoneNo: "Billing Phone No.*",
    phonePlaceholder: "Enter phone number *",
    billingEmail: "Billing Email*",
    emailPlaceholder: "Enter Billing Email",
    driverDetails: "Driver Details",
    customerVerificationStatus: "Customer Verification Status :",
    enterNationalInsuranceNumber: "Enter National Insurance Number",
    enterYourProfession: "Enter Your Profession",
    enterDriving: "Enter Driving",
    profileImage: "profile image",
    number: "Number",
    image: "Image",
    uploadBack: "Upload back",
    uploadFront: "Upload front",
    issuedBy: "Issued By",
    document: "Document",
    selectDocument: "Select Document", 
    addFile: "Add File",
    noDataFound: "No data found",
    noDocumentsFound: "No documents found",
    documentUpdatedAt: "Document Updated at",
    editExpiryDate: "Edit Expiry Date",
    selectExpiryDate: "Select expiry date",
    selectExpiryDateUpload: "Please select an expiry date before uploading.",
    status: "Status",
    images: "Images",
    profession: "Profession",
    driving: "Driving",
    listOfDocumentsUploaded: "List of Documents Uploaded",
    listOfRequiredDocumentsUploaded: "List of Required Documents Uploaded",
    documentType: "Document Type",
    documentName: "Document Name",
    expiryDate: "Expiry Date",
    confirmDelete: "Confirm Delete",
    actions: "Actions",
    completed: "Completed",
    pending: "Pending",
    documentDeleteConfirmMsg: "Are you sure you want to delete this document?",
    address: "Address*",
    useRegisteredAddress: "Use Registered Address",
    billingEmailAddress: "Billing Email Address*",
    billingEmailLabel: "Billing Email Address",
    accountNumber: "Account Number",
    firstName: "First Name*",
    lastName: "Last Name*",
    firstNameLabel: "First Name",
    lastNameLabel: "Last Name",
    contactEmail: "Contact Email Address*",
    emailLabel: "Email Address",
    contactPhone: "Contact Phone No.*",
    registeredAddressCaps: "REGISTERED ADDRESS",
    tradingAddressCaps: "TRADING ADDRESS",
    billingInformationCaps: "BILLING INFORMATION",
    customerContactCaps: "CUSTOMER CONTACT",
    contactEmailInvalid: "Please enter a valid Contact email.",
    typeAddress: "Type Address",
    taxFees:"Taxes & Fees",
    vatTax: "VAT/TAX",
    registrationNum: "Registration Number",
    licenceNumber: "Driving Licence Number",
    invalidPhoneNumber: "Invalid phone number",
    streetZipcodeRequired:"Street/zipcode is required",
    locationRequired:"Location is required",
    onStartEmail:"We have emailed you on how to get started.",
    emailNotSeen: 'If you do not see the email in a few minutes, check your "Junk mail" or "spam folder".',
    registerNow:"Register Now",
    email:"Email",
    thankYou:"Thank you",
    pickUpLocation: "Pick-Up Location *",
    returnLocation: "Return Location *",
    pickUpDate: "Pick-Up Date *",
    pickUpTime: "Pick-Up Time *",
    dropOffDate: "Drop-off date *",
    searchVehicles:"Search Vehicles",
    chooseLocation:"Choose a location",
    vehicleGallery: "Vehicle Gallery",
    privacyPolicy: "Privacy Policy",
    termsAndConditions: "Terms and Conditions",
    dropOffTime: "Drop-off Time *",
    noVehiclesFound:"No vehicles found matching the selected criteria",

    noRecordFound: "Sorry, no matching records found!",
    vehicles: "Vehicles",
    endDate:"End Date",
    startDate: "Start Date",
    past:"Past",
    search: "Search",
    upcoming: "Upcoming",
    current: "Current",
    all: "All",
    more:"More",
    toBeAssigned: "To be assigned",
    ref: "ref",
    reservation:"Reservation",
    booking: "Booking",
    

    
    
  },
  validation: {
    billingEmailInvalid: "Please enter a valid Billing email.",
    billingEmailRequired: "Billing email is required.",
    phoneNumberRequired: "Phone number is required.",
    businessNameRequired: "Business name is required.",
    registeredAddressRequired: "Registered Address is required",
    registeredAddressCountryRequired: "Country is required",
    registeredAddressStateRequired: "State is required",
    registeredAddressCityRequired: "City is required",
    registeredAddressStreetRequired: "Street is required",
    tradingAddressRequired: "Trading Address is required",
    tradingAddressCountryRequired: "Country is required",
    tradingAddressStateRequired: "State is required",
    tradingAddressCityRequired: "City is required",
    tradingAddressStreetRequired: "Street is required",
    contactEmailRequired: "Contact email is required.",
    firstNameRequired: "First name is required.",
    lastNameRequired: "Last name is required.",
    addressRequired :"Address is required",
  },
  misc: {
    edit: "Edit",
    logOut: "Log Out",
    licence: "Licence",
    nationalInsuranceNumber: "National Insurance Number",
    cancel: "Cancel",
    save: "Save",
    status: {
      PENDING: "Pending",
      APPROVED: "Approved",
      DECLINED: "Declined",
    },
    delete: "Delete",
    create: "Create",
    signIn: "Sign In",
    select:"Select",

  },
  snackBar: {
    customerInfoSaved: "Customer Information Saved",
    documentDeleted: "Document deleted successfully",
    documentDeleteFailed: "Failed to delete document",
    documentDeleteError: "Error deleting document",
    documentMarkedForDeletion:
      "Document marked for deletion. Changes will be applied when you save.",
    profileImageUploaded: "Profile Image uploaded successfully",
    uploadImageFormatError: "Please only upload .jpeg/.jpg/.png image format!",
    selectDocumentType: "Please select document type",
    selectExpiryDate: "Please select document expiry date",
    fileSizeExceeded50mb: "File size exceeded limit of 50MB",
    fileSizeExceeded5mb: "File size exceeded limit of 5MB",
    uploadSuccess: "Document uploaded successfully",
    invalidUploadFormat: "Please only upload PDF, PNG, JPG or JPEG files",
    selectExpiryDateUpload: "Please select an expiry date before uploading",
    ImageUploaded: "Image uploaded successfully",
  },}
};
